import module from 'viaticos/module.js'

export const schema = {
  tipo_id: 'number',
  informacion: {
    acceso_solicitar: 'boolean',
    acceso_eliminar: 'boolean',
    autorizados: 'number',
    cerrado: 'boolean',
    eliminado: 'boolean',
    diastolerancia: 'number',
    fecha_inicial: 'date',
    fecha_final: 'date',
    fecha_limite: 'date',
    personal: 'boolean',
    revisarEnviado: 'boolean',
    revisarFecha: 'datetime',
    rid: 'boolean',
  },
  viaje: {
    fecha_inicial: 'date',
    fecha_final: 'date',
    tipo_viaje_id: 'number',
  },
}

export class ViaticosViaticoService {
  constructor ($http) {
    this.$http = $http
  }

  get (viaticoId) {
    return this.$http.get('api/viaticos/viaticos/viatico', {
      params: {
        viatico_id: viaticoId,
      },
      schema,
    })
  }

  delete (viaticoId) {
    return this.$http.delete('api/viaticos/viaticos/viatico', {
      params: {
        viatico_id: viaticoId,
      },
      schema,
    })
  }
}

module.service('ViaticosViaticoService', ViaticosViaticoService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico.js